// Decouples the non-React API client from AuthContext. The client signals an
// unauthorized response; AuthContext subscribes and reacts (clear auth, flag
// the session as expired). Uses a DOM event so neither side imports the other.

const UNAUTHORIZED_EVENT = 'auth:unauthorized';
// A 403 TermsNotAccepted from any authenticated call: the session is valid but
// the user never accepted the terms in force, and only the activation email
// records that acceptance. AuthContext clears auth and the login offers it.
const TERMS_REQUIRED_EVENT = 'auth:terms-required';
// A 403 MembershipNotAccepted from any authenticated call: the session is
// valid and the active membership is still INVITED. AuthContext clears auth,
// and the login screen asks the member to accept or reject the invitation.
const MEMBERSHIP_NOT_ACCEPTED_EVENT = 'auth:membership-not-accepted';

export function emitUnauthorized() {
  window.dispatchEvent(new Event(UNAUTHORIZED_EVENT));
}

export function onUnauthorized(handler) {
  window.addEventListener(UNAUTHORIZED_EVENT, handler);
  return () => window.removeEventListener(UNAUTHORIZED_EVENT, handler);
}

export function emitTermsRequired() {
  window.dispatchEvent(new Event(TERMS_REQUIRED_EVENT));
}

export function onTermsRequired(handler) {
  window.addEventListener(TERMS_REQUIRED_EVENT, handler);
  return () => window.removeEventListener(TERMS_REQUIRED_EVENT, handler);
}

export function emitMembershipNotAccepted() {
  window.dispatchEvent(new Event(MEMBERSHIP_NOT_ACCEPTED_EVENT));
}

export function onMembershipNotAccepted(handler) {
  window.addEventListener(MEMBERSHIP_NOT_ACCEPTED_EVENT, handler);
  return () =>
    window.removeEventListener(MEMBERSHIP_NOT_ACCEPTED_EVENT, handler);
}
